import { Column as Col } from 'react-table';

export type Column = {
  className?: string;
} & Col;

export enum Actions {
  Edit = 'Edit',
  Clone = 'Clone',
  Delete = 'Delete'
};